import * as config from 'src/config/config';
import { checkValue, getLocalStorageList } from 'src/components/common/helper';
import { feedStoreData, contentModuleData } from 'src/components/concierge/util/feedStoreData';
import { TagProps } from './module-util';
const { localStorageKey, urlPattern } = config.config.meso_concierge;



export const conciergeWishlistCount = () => {
  const feedData = feedStoreData();
  const { data: { content } } = feedData;

  // Get content module data
  const feedContentModules = contentModuleData(content, 'tileFilterModule');
  const exploreContentItems = feedContentModules?.exploreContentItems;

  const tempArray = [];
  const countList = [];
  let wishCount;
  let storedWishList

  if (checkValue(JSON.parse(getLocalStorageList(localStorageKey)))) {

    storedWishList = JSON.parse(getLocalStorageList(localStorageKey));

    if (checkValue(exploreContentItems)) {
      exploreContentItems?.map((uniqueKeys) => {

        tempArray.push(uniqueKeys.uniquekey);
      });
      storedWishList?.map((wlist) => {
        if (tempArray.includes(wlist)) {
          countList.push(wlist);
          // 
          wishCount = countList.length;
        } else {
          storedWishList.filter(data => data !== wlist)
          wishCount = storedWishList.length;
        }
      })
    }
  } else {
    wishCount = '';
  }

  return wishCount;
};

export const conciergeBaseUrl = () => {
  const feedData = feedStoreData();
  const { data: {
    mainUrl
  } } = feedData;

  return urlPattern.replace('{feedName}', mainUrl);
}

export const conciergeItineraryUrl = (baseUrl: string, itineraryUrlParam: string) => {
  return `${baseUrl}${itineraryUrlParam.indexOf('/') > -1 ? itineraryUrlParam : '/' + itineraryUrlParam}`;
};

export const getTranslateLoc = (feed: any, name: string, defalutValue: string) => {
  return checkValue(feed) && checkValue(feed[name]) ? feed[name] : defalutValue;
}

export const getTags = (tags) => {
  const tempTags = [];

  if (checkValue(tags, true)) {
    tags.map((tagItem) => {
      const tempTagProps: TagProps = {
        tagName: tagItem.text,
        tagLogo: tagItem.icon[0]?.url
      }
      tempTags.push(tempTagProps);
    });
  }
  return tempTags;
}